/* eslint-disable no-nested-ternary */
import React, {
  useContext, useEffect, useState,
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { NotificationContext } from '../../../contexts/Notification';
import { formatDate } from '../../../utils/time';
import TotalCard from '../../../components/admin/TotalCard';
import AdminDataTable from '../../../components/admin/AdminDataTable';
import OrganizationsM from '../../../images/OrganizationsM.png';
import { ORGANIZATIONS_TABLE_HEADERS } from '../../../utils/adminDataTableHeaders';
import Action from '../../../components/admin/Action';
import { Layout } from '../Layout';
import { parseFilterParams } from '../../../utils/fillter';

function Organizations() {
  const organizationMenuItems = [
    {
      label: 'Switch to Organization',
      link: '/organization/switch',
    },
    {
      label: 'Edit Organization',
      link: '/admin/organization/create',
    },
    {
      label: 'Delete',
      modal: true,
      color: '#E53935',
    },
  ];
  const [loading, setLoading] = useState(false);
  const { displayNotification } = useContext(NotificationContext);
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const page = query.get('page');
  const filterParams = parseFilterParams(query, 'organization');
  const userId = query.get('userId');
  const [organizations, setOrganizations] = useState([]);
  const [totalOrganizations, setTotalOrganizations] = useState([]);
  const [activeOrganizations, setActiveOrganizations] = useState([]);
  const [totalWorkspaces, setTotalWorkspaces] = useState([]);
  const [nonActiveOrganizations, setNonActiveOrganizations] = useState([]);
  const [currentPage, setCurrentPage] = useState(page ? parseInt(page, 10) : 1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCounts, setTotalCounts] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}`);
  };
  // eslint-disable-next-line max-len
  const getTotalWorkspaces = (organizations) => organizations?.map((organization) => organization.workspaces || []).flat();
  const fetchOrganizations = async () => {
    setLoading(true);
    const { success, data } = await sendRequest({
      method: 'post',
      url: API.ORGANIZATION.organizations(),
      data: {
        pageSize,
        page: currentPage,
        userId,
        filters: filterParams,
      },
      timeout: 30000,
    });
    if (success) {
      const filteredOrganizations = data.organizations?.map((item) => ({
        organizationName: item.name,
        totalWorkspaces: item.workspacesCount,
        totalUsers: item.userCount,
        currentPlan: 'Basic',
        healthStatus: 'Good',
        organizationStatus: item.status ? 'Active' : 'InActive',
        lastActivityDate: formatDate(item.updatedAt),
        action: <Action label={item.name} menuItems={organizationMenuItems} type="organization" />,
      }));
      setOrganizations(filteredOrganizations);
      setTotalPages(data?.pageInfo.totalPages ?? 1);
      setTotalCounts(data?.pageInfo.totalCounts ?? 0);
      setLoading(false);
      setTotalOrganizations(data.totalOrganizations);
      setActiveOrganizations(data.totalOrganizations?.filter((item) => item.status));
      setNonActiveOrganizations(data.totalOrganizations?.filter((item) => !item.status));
      setTotalWorkspaces(getTotalWorkspaces(data.totalOrganizations));
    } else {
      displayNotification({
        message: 'There was an issue fetching user data. Please try again',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    fetchOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, currentPage, search]);

  const cardData = [
    {
      id: 1,
      data: totalOrganizations,
      title: 'Total Organizations',
      tooltip: 'Total Organizations',
      color: '#0064FF',
    },
    {
      id: 2,
      data: activeOrganizations,
      title: 'Active Organizations',
      tooltip: 'Total Active Organizations',
      color: '#F19235',
    },
    {
      id: 3,
      data: nonActiveOrganizations,
      title: 'Inactive Organizations',
      tooltip: 'Total Non-Active Organizations',
      color: '#9457A5',
    },
    {
      id: 4,
      data: totalWorkspaces,
      title: 'Total Workspcaes',
      tooltip: 'Total Workspcaes',
      color: '#FF6A6A',
    },
  ];
  return (
    <Layout>
      <div className="screen-wrapper">
        <div className="screen-header">
          <div className="total-card-wrapper">
            {cardData && cardData.map((item, index) => (
              <TotalCard
                key={index}
                data={item.data}
                title={item.title}
                tooltip={item.tooltip}
                color={item.color}
              />
            ))}
          </div>
          <div className="one-card-container">
            <AdminDataTable
              heading="organizations"
              data={organizations}
              title="Organizations Management"
              icon={OrganizationsM}
              headers={ORGANIZATIONS_TABLE_HEADERS}
              loading={loading}
              currentPage={currentPage}
              totalPages={totalPages}
              totalCounts={totalCounts}
              pageSize={pageSize}
              onPageSize={setPageSize}
              onCurrentPage={handlePageChange}
              // eslint-disable-next-line react/jsx-boolean-value
              showButton={true}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Organizations;
